import type { ReactElement } from 'react'

import { updatePlatformHeader } from '../services/api/auth'
import { setPlatformForLogs } from '../services/datadog'
import { resolveNativeAuthRedirectUrl } from '../utils/nativeAuthRedirect'
import { BaseSignInRoute } from './BaseSignInRoute'

export const SignInAndroidRoute = (): ReactElement => {
  const platform = 'android'

  updatePlatformHeader(platform)
  setPlatformForLogs(platform)

  // Returns the resolved callback URL instead of navigating: BaseSignInRoute hands it
  // to useNativeAppHandoff, which fires the redirect and detects a blocked Custom Tab
  // hop instead of leaving a blank page (see nativeAuthRedirect.ts).
  return BaseSignInRoute(
    (accessToken, authenticationCode, secondaryFactor, redirectTo) =>
      resolveNativeAuthRedirectUrl(accessToken, redirectTo ?? '', authenticationCode, secondaryFactor),
    platform,
  )
}
